<div class="modal show">
	<div class="modal__content">
		<app-loader *ngIf="isLoading"></app-loader>
		<div *ngIf="!isLoading" class="modal__content__body">
			<div class="body__header">
				<h2>{{ fee.info.subtitle }}</h2>
				<span>{{ fee.info.title }} </span>
			</div>
			<div *ngIf="!(accessibilityService.accessibility$ | async)" class="collapse-group">
				<ng-container *ngFor="let detail of fee.details; trackBy: trackByFeeDetailID">
					<div
						class="collapse"
						[ngClass]="{ 'collapse--expanded': detailIdSelected === detail.product_detail_id, 'not-end': detail.hasScroll }"
						(click)="
							detailIdSelected = detailIdSelected === detail.product_detail_id ? -1 : detail.product_detail_id;
							checkHeighValue($event, detail)
						"
					>
						<div class="collapse__header">
							<div class="collapse__header__title">
								<i class="icon--sm" [ngClass]="'icon-' + detail.icon"></i>
								<div class="title__text">
									<h5>{{ detail.title }}</h5>
									<span>{{ detail.subtitle }}</span>
								</div>
							</div>
							<i class="icon-triangle-down"></i>
						</div>
						<div [innerHTML]="detail.description" class="collapse__body" #scrollableContainer></div>
					</div>
				</ng-container>
			</div>
			<div *ngIf="accessibilityService.accessibility$ | async" class="collapse-carousel">
				<div class="collapse-group">
					<ng-container *ngFor="let detail of fee.details; trackBy: trackByFeeDetailID; let i = index">
						<div class="collapse" [ngClass]="{ show: indexSelected === i }">
							<div class="collapse__header">
								<div class="collapse__header__title">
									<i class="icon--sm" [ngClass]="'icon-' + detail.icon"></i>
									<div class="title__text">
										<h5>{{ detail.title }}</h5>
										<span>{{ detail.subtitle }}</span>
									</div>
								</div>
							</div>
							<div [innerHTML]="detail.description" class="collapse__body"></div>
						</div>
					</ng-container>
				</div>
				<div class="collapse-carousel__pagination">
					<button class="button-icon" (click)="subtract()">
						<i class="icon-arrow-left"></i>
					</button>
					<span>{{ indexSelected + 1 }}/{{ fee.details.length }}</span>
					<button class="button-icon" (click)="add()">
						<i class="icon-arrow-right"></i>
					</button>
				</div>
			</div>
		</div>
		<div class="modal__content__buttons">
			<button class="button" type="button" (click)="dialogRef.close()">
				<i class="icon-chevron-left"></i>
				{{ 'GENERAL.BACK' | translate }}
			</button>
		</div>
	</div>
</div>
